import UserTabs from "./user-tabs.component";

export default UserTabs;
